export const FOCUS_VISIBLE_RING_CLASS =
  'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#005fcc] focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-white';
